const calcTotal = (data) => {
  let totalRewards = [];
  let categories = [];
  for (let obj of data) {
    let rewardObjects = [];
    for (let item of obj?.categories) {
      categories.push({ ...item });
      for (let rew of item?.rewards) {
        rewardObjects.push({ ...rew, reward: parseFloat(rew.reward || 0), ...obj });
      }
    }

    const totalRewars = rewardObjects.reduce((acc, cur) => {
      const item =
        acc.length > 0 &&
        acc.find(
          ({ base_canal_id, indicator_type, incentive_type }) =>
            base_canal_id === cur.base_canal_id &&
            indicator_type === cur.indicator_type &&
            incentive_type === cur.incentive_type
        );
      if (item) {
        item.reward += cur.reward;
      } else acc.push({ ...cur });
      return acc;
    }, []);
    totalRewards.push(...totalRewars);
  }

  const totalCategories = categories.reduce((acc, cur) => acc + parseFloat(cur.boss_reward), 0);

  const totalGrops = totalRewards?.reduce((acc, cur) => {
    const item =
      acc.length > 0 &&
      acc.find(
        ({ base_canal_id, incentive_type, indicator_type }) =>
          base_canal_id === cur.base_canal_id &&
          incentive_type === cur.incentive_type &&
          indicator_type === cur.indicator_type
      );
    if (item) {
      item.reward += cur.reward;
    } else acc.push({ ...cur });
    return [...acc];
  }, []);

  return { totalGroups: totalGrops, bossReward: { total: totalCategories, categories } };
};

export { calcTotal };
